import React from 'react';
import {
  Box, Container, ScopedCssBaseline, Stack, ThemeProvider, Typography,
} from '@mui/material';

import { themeExpert } from '../../theme/expert';

/**
 * La coquille des écrans de l'expert : titre, sous-titre, actions, contenu.
 *
 * Chaque écran redéfinissait sa propre en-tête — ici un bandeau bleu, là un
 * titre à emoji, ailleurs rien du tout. Une seule coquille, et l'expert
 * reconnaît immédiatement où il est.
 *
 * `ScopedCssBaseline` isole du CSS Bootstrap encore importé globalement, le
 * temps que les écrans restants soient repris.
 */
export default function CoquilleExpert({ titre, sous_titre, actions, children,
                                         large = true }) {
  return (
    <ThemeProvider theme={themeExpert}>
      <ScopedCssBaseline>
        <Box sx={{ bgcolor: 'background.default',
                   minHeight: 'calc(100vh - 68px)' }}>
          <Container maxWidth={large ? false : 'lg'}
                     sx={{ py: { xs: 2.5, md: 4 },
                           px: { xs: 2, md: 3 },
                           maxWidth: large ? 1600 : undefined }}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={2}
              sx={{ mb: 3, alignItems: { sm: 'flex-start' },
                    justifyContent: 'space-between' }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="h1">{titre}</Typography>
                {sous_titre && (
                  <Typography variant="body2" color="text.secondary"
                              sx={{ mt: 0.5 }}>
                    {sous_titre}
                  </Typography>
                )}
              </Box>
              {actions && (
                <Stack direction="row" spacing={1.5} flexWrap="wrap"
                       useFlexGap sx={{ flexShrink: 0 }}>
                  {actions}
                </Stack>
              )}
            </Stack>

            {children}
          </Container>
        </Box>
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}
